import { render } from "./UsageAlert.vue?vue&type=template&id=6ffee42e&scoped=true&ts=true"
import script from "./UsageAlert.vue?vue&type=script&lang=ts"
export * from "./UsageAlert.vue?vue&type=script&lang=ts"

import "./UsageAlert.vue?vue&type=style&index=0&id=6ffee42e&lang=scss&scoped=true"
import "./UsageAlert.vue?vue&type=style&index=1&id=6ffee42e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ffee42e"]])

export default __exports__